import { Link } from "react-router-dom/dist"
import { useEffect, useState } from "react"
import { useAuth } from "../context/authContext"
import { isShopifySeller } from "../firebase/shopify"

const ProfileTabs = ({ activeTab }) => {
    const [showTabs, setShowTabs] = useState(false)
    const { user } = useAuth()
    const [isSeller, setIsSeller] = useState(false)

    useEffect(() => {
        if (!user?.uid) {
            setIsSeller(false)
            return
        }
        isShopifySeller(user.uid).then(setIsSeller)
    }, [user?.uid])

    const tabs = [
        {
            title: "Profile/Membership",
            link: "/my-profile"
        },
        {
            title: "Offers",
            link: "/offers"
        },
        {
            title: "Purchase/Sale History",
            link: "/purchase-sale"
        },
        {
            title: "Ratings And Reviews",
            link: "/ratings"
        },
        {
            title: "Your Listings",
            link: "/my-listings"
        },
        ...(isSeller ? [{
            title: "Shopify Listings",
            link: "/shopify-listings"
        }] : []),
        {
            title: "Payment Settings",
            link: "/payment-settings"
        },
        {
            title: "Blocked Sellers",
            link: "/blocked-sellers"
        }
    ]

    return (
        <div>
            <hr className="divider" />
            <div className="md:flex hidden flex-wrap lg:flex-nowrap items-center gap-2 lg:gap-6">
                {tabs.map((tab) => (
                    <Link
                        key={tab.title}
                        to={tab.link}
                        className={`relative w-[180px] justify-center text-sm flex items-center py-4 px-6 whitespace-nowrap border-[1px] border-gray
                ${tab.title === activeTab
                                ? "bg-white text-black"
                                : "text-white hover:bg-white hover:text-[#141414]"
                            }`}
                    >
                        {tab.title}
                    </Link>
                ))}
            </div>

            <div className="md:hidden relative w-full border-[1px] border-primary bg-white h-[50px] z-[9]">
                <div className="w-full h-full flex justify-center items-center relative cursor-pointer" onClick={() => setShowTabs(!showTabs)}>
                    <div className="">{activeTab}</div>
                    <img className="absolute top-[50%] right-5 -translate-y-1/2" src="/assets/icons/icon-arrow-drop-down-black.svg" />
                </div>

                {
                    showTabs &&
                    <div className="absolute border-[1px] border-[#333] border-b-0 w-full top-[100%] mt-1 bg-[#1f1f1f] text-white z-[10]">
                        <ul>
                            {tabs.map((tab) => (
                                <li key={tab.title} className="text-center border-b-[1px] border-[#333]">
                                    <Link to={tab.link} className="flex relative py-3 text-center justify-center">
                                        {tab.title}
                                        <img src="/assets/icons/icon-arrow-right-white.svg" alt="arrow" className="absolute top-[50%] right-5 -translate-y-1/2" />
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                }
            </div>

            <hr className="divider" />
        </div>
    )
}

export default ProfileTabs